import '.a{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.aj{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.e5{background:var(--palette-white);}.ssr-plugin'
import '.al{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.fw{justify-content:stretch;}.ssr-plugin'
import '.b2{position:sticky;}.ssr-plugin'
import '.b3{top:0px;}.ssr-plugin'
import '.b7{z-index:10;}.ssr-plugin'
import '.fx{padding-block:1rem;}.ssr-plugin'
import '.fy{height:3rem;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.ar{flex-wrap:wrap;}.ssr-plugin'
import '.fz{margin-bottom:0px;}.ssr-plugin'
import '.g0{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fc{margin-top:2rem;}.ssr-plugin'
import '.g1{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="a a2 aj b e5"
      >
        <div className="al a r aj b"
        >
          <div className="ab a b fw b2 b3 b7 e5"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fx fy a ao r ar"
            >
              <styled.span className="fz"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="g0 a b a2 fc g1 ab"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
